import React from 'react';

export interface FullLengthButtonProps {
  text: string;
  buttonStyle: string;
  textStyle: string;
  leftIconSrc?: string; // Optional path to the left icon or image
  rightIconSrc?: string | React.ReactNode; // Optional path to the right arrow icon
  backgroundImgSrc?: string; // Optional background image for the button
  onClick?: () => void; // Optional click handler
}

const FullLengthButton: React.FC<FullLengthButtonProps> = ({
  text,
  leftIconSrc,
  rightIconSrc,
  buttonStyle,
  textStyle,
  backgroundImgSrc,
  onClick,
}) => {
  return (
    <div
      className={buttonStyle}
      style={{
        backgroundImage: backgroundImgSrc
          ? `url(${backgroundImgSrc})`
          : undefined,
      }}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {/* Left Icon Section */}
      {leftIconSrc && (
        <img
          src={leftIconSrc}
          alt="Left Icon"
          className="h-6 w-6 mr-4 flex-shrink-0"
        />
      )}

      {/* Text Section */}
      <p className={textStyle}>{text}</p>

      {/* Right Arrow Icon */}
      {rightIconSrc && rightIconSrc}
    </div>
  );
};

export default FullLengthButton;
